import type { LegendConfig } from "components/Dashboard/ChartLegend";

import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Where the overview donuts put their legend. Beside the donut needs about
 * 400px a column, which three columns only have on an xl screen; narrower, the
 * legend goes underneath, wrapping onto as many rows as it needs.
 */
export function useSubmissionDonutLegend(): {
  legend: LegendConfig;
  legendSx?: { flexWrap: "wrap"; justifyContent: "center" };
} {
  const theme = useTheme();
  const roomBeside = useMediaQuery(theme.breakpoints.up("xl"));
  return roomBeside
    ? { legend: { position: "right", direction: "column" } }
    : {
        legend: { position: "below", direction: "row" },
        legendSx: { flexWrap: "wrap", justifyContent: "center" },
      };
}
